export const acceleratorsData = [
  {
    rank: 1,
    name: "Y Combinator",
    companies: 7089,
    leader: "Garry Tan",
    investment: "$125K for 7% + $375K (uncapped)",
    fee: "Free",
    length: "12 weeks",
    batches: "4x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "Mountain View, CA, USA",
    format: "In-person required",
    topAlumni: "Airbnb, Stripe, Dropbox",
    alumniExits: 1500,
    rating: 25
  },
  {
    rank: 2,
    name: "A16Z Speedrun",
    companies: 224,
    leader: "Andrew Chen",
    investment: "$750,000 for unknown equity stake",
    fee: "Free",
    length: "12 weeks",
    batches: "2x per year",
    companyTypes: "Gaming+",
    acceptance: "<1%",
    location: "Los Angeles, CA, USA",
    format: "In-person required for specific program events",
    topAlumni: "Opendoor, Brex, Caffeine",
    alumniExits: "Unknown",
    rating: 24
  },
  {
    rank: 3,
    name: "Sequoia Arc",
    companies: 2215,
    leader: "Alfred Lin",
    investment: "Investment terms not public",
    fee: "Free",
    length: "12 weeks",
    batches: "1x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "San Francisco, CA, USA",
    format: "In-person required for specific program events",
    topAlumni: "Pydantic, Flagship, Mindy",
    alumniExits: "Unknown",
    rating: 22
  },
  {
    rank: 4,
    name: "Techstars",
    companies: 6168,
    leader: "David Cohen",
    investment: "$20,000 for 6% (+ optional $100K on $3M)",
    fee: "Free",
    length: "13 weeks",
    batches: "1-4x per year",
    companyTypes: "All",
    acceptance: "1%",
    location: "Boulder, CO, USA",
    format: "In-person required",
    topAlumni: "SendGrid, ClassPass, DigitalOcean",
    alumniExits: 350,
    rating: 20
  },
  {
    rank: 5,
    name: "500 Global",
    companies: 3163,
    leader: "Christine Tsai",
    investment: "$150,000 for 6%",
    fee: "$37,500",
    length: "16 weeks",
    batches: "3x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "San Francisco, CA, USA",
    format: "In-person required",
    topAlumni: "Canva, Grab, Talkdesk",
    alumniExits: 110,
    rating: 20
  },
  {
    rank: 6,
    name: "Dreamit Ventures",
    companies: 321,
    leader: "Darren Sandberg",
    investment: "$500,000 for 8%",
    fee: "$2,500",
    length: "13 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "3%",
    location: "Philadelphia, PA, USA",
    format: "In-person required for specific program events",
    topAlumni: "LevelUp, HouseCall Pro, Elevate",
    alumniExits: 70,
    rating: 20
  },
  {
    rank: 7,
    name: "Surge",
    companies: 208,
    leader: "Rajan Anandan",
    investment: "Up to $3 million for up to 15%",
    fee: "Free",
    length: "16 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "Unknown",
    location: "Bengaluru, India",
    format: "In-person required",
    topAlumni: "Unacademy, OYO, Tejas Networks",
    alumniExits: 23,
    rating: 19
  },
  {
    rank: 8,
    name: "HAX",
    companies: 610,
    leader: "Duncan Turner",
    investment: "$250,000 for 10%",
    fee: "Free",
    length: "20 weeks",
    batches: "2x per year",
    companyTypes: "Hardware",
    acceptance: "<3%",
    location: "Shenzhen, China",
    format: "In-person required",
    topAlumni: "Lumos, Makeblock, Simbe Robotics",
    alumniExits: 30,
    rating: 19
  },
  {
    rank: 9,
    name: "Seedcamp",
    companies: 606,
    leader: "Carlos Eduardo Espinal",
    investment: "£120,000 for 7.5%",
    fee: "Free",
    length: "12 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "London, United Kingdom",
    format: "Virtual",
    topAlumni: "TransferWise, Revolut, UiPath",
    alumniExits: 60,
    rating: 19
  },
  {
    rank: 10,
    name: "NFX",
    companies: 407,
    leader: "James Currier",
    investment: "$120K for 8%",
    fee: "No fee information available",
    length: "12 weeks",
    batches: "3x per year",
    companyTypes: "All",
    acceptance: "2%",
    location: "San Francisco, CA, USA",
    format: "Virtual",
    topAlumni: "DoorDash, Mammoth Biosciences, Patreon",
    alumniExits: 24,
    rating: 19
  },
  {
    rank: 11,
    name: "Cedars-Sinai Accelerator",
    companies: 88,
    leader: "Nirdesh K Gupta",
    investment: "$100,000 for unknown terms",
    fee: "Free",
    length: "12 weeks",
    batches: "Unknown",
    companyTypes: "BioTech",
    acceptance: "Unknown",
    location: "Los Angeles, CA, USA",
    format: "Hybrid (specifics not public)",
    topAlumni: "LIVONGO, WELL Health, AppliedVR",
    alumniExits: 25,
    rating: 19
  },
  {
    rank: 12,
    name: "Disney Accelerator",
    companies: 55,
    leader: "Bonnie Rosen",
    investment: "Investment terms not public",
    fee: "Free",
    length: "30 weeks",
    batches: "1x per year",
    companyTypes: "Media",
    acceptance: "<1%",
    location: "Los Angeles, CA, USA",
    format: "In-person required for specific program events",
    topAlumni: "Epic Games, Playbuzz, Wakie",
    alumniExits: 19,
    rating: 19
  },
  {
    rank: 13,
    name: "Soma Fellows",
    companies: 40,
    leader: "Aneel Ranadive",
    investment: "Up to $1,000,000 for unknown equity",
    fee: "Free",
    length: "12 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "San Francisco, CA, USA",
    format: "In-person required",
    topAlumni: "Unknown",
    alumniExits: "Unknown",
    rating: 18
  },
  {
    rank: 14,
    name: "AI2 Incubator",
    companies: 50,
    leader: "Jacob Colker",
    investment: "Up to $500,000 for unknown equity",
    fee: "Free",
    length: "12 weeks",
    batches: "1x per year",
    companyTypes: "Artificial Intelligence",
    acceptance: "<1%",
    location: "Seattle, WA, USA",
    format: "In-person required",
    topAlumni: "Unknown",
    alumniExits: "Unknown",
    rating: 18
  },
  {
    rank: 15,
    name: "IndieBio",
    companies: 529,
    leader: "Po Bronson",
    investment: "$275K for 8%",
    fee: "$50,000",
    length: "16 weeks",
    batches: "2x per year",
    companyTypes: "BioTech",
    acceptance: "5%",
    location: "San Francisco, CA, USA",
    format: "In-person required 1 day/week",
    topAlumni: "NotCo, Memphis Meats, Geltor",
    alumniExits: 20,
    rating: 18
  },
  {
    rank: 16,
    name: "Plug and Play",
    companies: 1948,
    leader: "Saeed Amidi",
    investment: "Investment terms not public.",
    fee: "Free",
    length: "12 weeks",
    batches: "4x per year",
    companyTypes: "All",
    acceptance: "<1%",
    location: "Sunnyvale, CA, USA",
    format: "In-person required",
    topAlumni: "PayPal, Dropbox, N26",
    alumniExits: 140,
    rating: 18
  },
  {
    rank: 17,
    name: "SkyDeck Berkeley",
    companies: 485,
    leader: "Caroline Winnett",
    investment: "$200K for 7.5%",
    fee: "$5,000",
    length: "24 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "<3%",
    location: "Berkeley, CA, USA",
    format: "In-person required",
    topAlumni: "Lime, Cerebras Systems, Flutterwave",
    alumniExits: 30,
    rating: 18
  },
  {
    rank: 18,
    name: "Entrepreneur First",
    companies: 451,
    leader: "Alice Bentinck",
    investment: "$125K for 8%",
    fee: "Free",
    length: "12 weeks",
    batches: "2x per year",
    companyTypes: "All",
    acceptance: "3%",
    location: "London, United Kingdom",
    format: "In-person required",
    topAlumni: "Tractable, Magic Pony Technology, Bloomsbury AI",
    alumniExits: 100,
    rating: 18
  },
  {
    rank: 19,
    name: "MIT delta v",
    companies: 226,
    leader: "Lea Gabrielle Potts",
    investment: "$20,000 grant",
    fee: "Free",
    length: "14 weeks",
    batches: "1x per year",
    companyTypes: "All",
    acceptance: "Unknown",
    location: "Boston, MA, USA",
    format: "In-person required",
    topAlumni: "Ginkgo Bioworks, Formlabs, New Valence Robotics (NVBots)",
    alumniExits: 24,
    rating: 18
  },
      {
      rank: 20,
      name: "HF0",
      companies: 25,
      leader: "Dave Fontenot",
      investment: "$1,000,000 for 5% equity",
      fee: "Free",
      length: "12 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "<1%",
      location: "San Francisco, CA, USA",
      format: "In-person required",
      topAlumni: "Unknown",
      alumniExits: "Unknown",
      rating: 17
    },
    {
      rank: 21,
      name: "SOSV",
      companies: 2816,
      leader: "William Bao Bean",
      investment: "$250,000 for 8%",
      fee: "$40,000+ (varies by program)",
      length: "16 weeks",
      batches: "2x per year",
      companyTypes: "Deep Tech",
      acceptance: "<2%",
      location: "Princeton, NJ, USA",
      format: "In-person required",
      topAlumni: "Revolut, NotCo, Formlabs",
      alumniExits: 180,
      rating: 17
    },
    {
      rank: 22,
      name: "AngelPad",
      companies: 184,
      leader: "Thomas Korte",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "10 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "San Francisco, CA, USA",
      format: "In-person required",
      topAlumni: "Postmates, CoverHound, Grovo",
      alumniExits: 60,
      rating: 17
    },
    {
      rank: 23,
      name: "Startmate",
      companies: 263,
      leader: "Michael Batko",
      investment: "$120K for 8%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "5%",
      location: "Sydney, Australia",
      format: "Hybrid (specifics not public)",
      topAlumni: "Zoox, Morse Micro, Bright",
      alumniExits: 40,
      rating: 17
    },
    {
      rank: 24,
      name: "MassChallenge",
      companies: 3205,
      leader: "Cait Brumme",
      investment: "Investment terms not public.",
      fee: "Free (non-profit)",
      length: "16 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "<10%",
      location: "Boston, MA, USA",
      format: "In-person required for specific program events",
      topAlumni: "Ginkgo Bioworks, Toast, Soofa",
      alumniExits: 213,
      rating: 17
    },
    {
      rank: 25,
      name: "Antler",
      companies: 1560,
      leader: "Magnus Grimeland",
      investment: "$250,000 for 9% + matches 1:1 additional capital raised up to $250,000",
      fee: "$70,000",
      length: "10 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<3%",
      location: "Singapore",
      format: "In-person required",
      topAlumni: "Fiverr, Flutterwave, Prospa",
      alumniExits: 23,
      rating: 17
    },
    {
      rank: 26,
      name: "LAUNCH",
      companies: 554,
      leader: "Jason Calacanis",
      investment: "$100K for 6%",
      fee: "Free",
      length: "6 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "<1%",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "Udemy, Marqeta, Thumbtack",
      alumniExits: 10,
      rating: 17
    },
    {
      rank: 27,
      name: "Forum Ventures",
      companies: 474,
      leader: "Michael Cardamone",
      investment: "$100K for 7.5%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "B2B SaaS",
      acceptance: "<3%",
      location: "New York City, NY, USA",
      format: "Virtual",
      topAlumni: "Auth0, Buffer, MileIQ",
      alumniExits: 25,
      rating: 17
    },
    {
      rank: 28,
      name: "StartX (Stanford-StartX Fund)",
      companies: 338,
      leader: "Kyle Wong",
      investment: "Does not invest.",
      fee: "Free (non-profit)",
      length: "10 weeks",
      batches: "3x per year",
      companyTypes: "All",
      acceptance: "8%",
      location: "Palo Alto, CA, USA",
      format: "In-person required last 2 weeks of program",
      topAlumni: "Healthcare.ai, Kodiak Sciences, Lemonade",
      alumniExits: 90,
      rating: 17
    },
    {
      rank: 29,
      name: "Mucker Capital",
      companies: 277,
      leader: "Erik Rannala",
      investment: "$100K for 10%",
      fee: "Free",
      length: "12 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "<5%",
      location: "Santa Monica, CA, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Honey, ServiceTitan, Next Insurance",
      alumniExits: 43,
      rating: 17
    },
    {
      rank: 30,
      name: "AlphaLab",
      companies: 156,
      leader: "Aaron Tainter",
      investment: "Up to $100,000 for unknown terms",
      fee: "2% equity",
      length: "Undisclosed",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Pittsburgh, PA, USA",
      format: "In-person required for specific program events",
      topAlumni: "Duolingo, JazzHR, NoWait",
      alumniExits: 13,
      rating: 17
    },
    {
      rank: 31,
      name: "Google for Startups",
      companies: 1642,
      leader: "Ashley Francisco",
      investment: "Not able to obtain information.",
      fee: "Free",
      length: "10 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<2%",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "Carta, Stripe, Airbnb",
      alumniExits: "Unknown",
      rating: 16
    },
    {
      rank: 32,
      name: "South Park Commons",
      companies: 714,
      leader: "Ruchi Sanghvi",
      investment: "$400,000 for 7%",
      fee: "Free",
      length: "24 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<2%",
      location: "San Francisco, CA, USA",
      format: "In-person required",
      topAlumni: "Applied Intuition, PostHog, Apoorva Mehta",
      alumniExits: 4,
      rating: 16
    },
    {
      rank: 33,
      name: "East Ventures",
      companies: 643,
      leader: "Willson Cuaca",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "14 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Jakarta, Indonesia",
      format: "Unknown",
      topAlumni: "Tokopedia, Traveloka, Ruangguru",
      alumniExits: 48,
      rating: 16
    },
    {
      rank: 34,
      name: "Alchemist Accelerator",
      companies: 605,
      leader: "Ravi Belani",
      investment: "$25K for 5%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "Enterprise Tech",
      acceptance: "<3%",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "Rigetti Computing, LaunchDarkly, RigUp",
      alumniExits: 12,
      rating: 16
    },
    {
      rank: 35,
      name: "Startupbootcamp",
      companies: 605,
      leader: "Nektarios Liolios",
      investment: "$40K for 8%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<2%",
      location: "Amsterdam, Netherlands",
      format: "Hybrid (specifics not public)",
      topAlumni: "Revolut, WeFarm, Relay42",
      alumniExits: 62,
      rating: 16
    },
    {
      rank: 36,
      name: "Pioneer Fund",
      companies: 568,
      leader: "Jason Gray",
      investment: "Investment terms not public",
      fee: "Free",
      length: "8 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<3%",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "Loom, Mixpanel, Rippling",
      alumniExits: 20,
      rating: 16
    },
    {
      rank: 37,
      name: "(ERA) Entrepreneurs Roundtable Accelerator",
      companies: 395,
      leader: "Jonathan Axelrod",
      investment: "$100K for 8%",
      fee: "4% equity",
      length: "14 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "2%",
      location: "New York City, NY, USA",
      format: "Virtual",
      topAlumni: "Triplemint, Hungryroot, Floating Point",
      alumniExits: 79,
      rating: 16
    },
    {
      rank: 38,
      name: "Outlier Ventures",
      companies: 327,
      leader: "Stephan Apel",
      investment: "Up to $100K stipend",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "Web3",
      acceptance: "2%",
      location: "London, United Kingdom",
      format: "Virtual",
      topAlumni: "Boson Protocol, Fetch.ai, Blockchain.com",
      alumniExits: 16,
      rating: 16
    },
    {
      rank: 39,
      name: "CyberAgent Capital",
      companies: 278,
      leader: "Nguyen Minh Tuan",
      investment: "Investment terms not public",
      fee: "Free",
      length: "Undisclosed",
      batches: "Unknown",
      companyTypes: "CyberSecurity",
      acceptance: "Unknown",
      location: "Tokyo, Japan",
      format: "In-person required",
      topAlumni: "17LIVE, TikTok, Kuaishou",
      alumniExits: 77,
      rating: 16
    },
    {
      rank: 40,
      name: "Springcamp",
      companies: 257,
      leader: "inQ CHOI",
      investment: "$50K for 7%",
      fee: "No fee information available",
      length: "Undisclosed",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Seoul, South Korea",
      format: "Virtual",
      topAlumni: "Coupang, Toss, Baemin",
      alumniExits: 70,
      rating: 16
    },
    {
      rank: 41,
      name: "Elemental Impact",
      companies: 211,
      leader: "Dawn Lippert",
      investment: "Up to $1,000,000 grant",
      fee: "Free (non-profit)",
      length: "24 weeks",
      batches: "1x per year",
      companyTypes: "Clean Tech",
      acceptance: "Unknown",
      location: "Oakland, CA, USA",
      format: "Virtual",
      topAlumni: "Spanx, Goodr, PopSockets",
      alumniExits: 21,
      rating: 16
    },
    {
      rank: 42,
      name: "EIT InnoEnergy",
      companies: 211,
      leader: "Ryan Dings",
      investment: "Investment terms not public",
      fee: "€18,000",
      length: "24 weeks",
      batches: "1x per year",
      companyTypes: "Clean Tech",
      acceptance: "Unknown",
      location: "Eindhoven, Netherlands",
      format: "Hybrid (specifics not public)",
      topAlumni: "Northvolt, Skeleton Technologies, Tado",
      alumniExits: 21,
      rating: 16
    },
    {
      rank: 43,
      name: "NDRC",
      companies: 207,
      leader: "Malaika Judd",
      investment: "€100k uncapped with 20% discount",
      fee: "Free",
      length: "24 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Dublin, Ireland",
      format: "Virtual",
      topAlumni: "Stripe, Revolut, Remitly",
      alumniExits: 27,
      rating: 16
    },
    {
      rank: 44,
      name: "MetaProp",
      companies: 176,
      leader: "Aaron Block",
      investment: "$150,000 for 6%",
      fee: "Free",
      length: "13 weeks",
      batches: "4x per year",
      companyTypes: "Real Estate Tech",
      acceptance: "Unknown",
      location: "New York City, NY, USA",
      format: "In-person required",
      topAlumni: "Haven, VergeSense, Spruce",
      alumniExits: 25,
      rating: 16
    },
    {
      rank: 45,
      name: "Founder Friendly Labs",
      companies: 176,
      leader: "Mendel Chuang",
      investment: "Investment terms not public",
      fee: "No fee information available",
      length: "8 weeks",
      batches: "Unknown",
      companyTypes: "Unknown",
      acceptance: "Unknown",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "Coinbase, Soylent, Cruise",
      alumniExits: 4,
      rating: 16
    },
    {
      rank: 46,
      name: "Future Fifty",
      companies: 174,
      leader: "Carolyn Dawson",
      investment: "Investment terms not public",
      fee: "No fee information available",
      length: "52 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "London, United Kingdom",
      format: "Virtual",
      topAlumni: "Skyscanner, Deliveroo, TransferWise",
      alumniExits: 60,
      rating: 16
    },
    {
      rank: 47,
      name: "Betaworks",
      companies: 232,
      leader: "John Borthwick",
      investment: "$250K uncapped with 25% discount",
      fee: "No fee information available",
      length: "12 weeks",
      batches: "Unknown",
      companyTypes: "Media",
      acceptance: "Unknown",
      location: "New York City, NY, USA",
      format: "Virtual",
      topAlumni: "Giphy, Bitly, Dots",
      alumniExits: 12,
      rating: 15
    },
    {
      rank: 48,
      name: "Startup Wise Guys",
      companies: 598,
      leader: "Cristobal Alonso",
      investment: "£100K for 9%",
      fee: "£35,000",
      length: "13 weeks",
      batches: "3x per year",
      companyTypes: "B2B SaaS",
      acceptance: "18%",
      location: "Tallinn, Estonia",
      format: "Hybrid (specifics not public)",
      topAlumni: "Bolt, Sun Finance Group, Modash",
      alumniExits: 30,
      rating: 15
    },
    {
      rank: 49,
      name: "MedTech Innovator",
      companies: 391,
      leader: "Paul Grand",
      investment: "Does not invest.",
      fee: "Free (non-profit)",
      length: "16 weeks",
      batches: "1x per year",
      companyTypes: "MedTech",
      acceptance: "5%",
      location: "Los Angeles, CA, USA",
      format: "Virtual",
      topAlumni: "AliveCor, Eko, AdvaMed",
      alumniExits: 62,
      rating: 15
    },
    {
      rank: 50,
      name: "Flat6Labs",
      companies: 370,
      leader: "Ramez El-Serafy",
      investment: "$150K for 6%",
      fee: "Free",
      length: "16 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<10%",
      location: "Cairo, Egypt",
      format: "Hybrid (specifics not public)",
      topAlumni: "Instabug, FlexxPay, Chefaa",
      alumniExits: 30,
      rating: 15
    },
    {
      rank: 51,
      name: "Village Capital",
      companies: 359,
      leader: "Allie Burns",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "2 weeks",
      batches: "3x per year",
      companyTypes: "Impact",
      acceptance: "5-10%",
      location: "Washington, DC, USA",
      format: "Virtual",
      topAlumni: "Lendable, FarmDrive, InVenture",
      alumniExits: 19,
      rating: 15
    },
    {
      rank: 52,
      name: "IQT",
      companies: 315,
      leader: "Steve Bowsher",
      investment: "Does not invest",
      fee: "Free (non-profit)",
      length: "14 weeks",
      batches: "2x per year",
      companyTypes: "CyberSecurity",
      acceptance: "3%",
      location: "Arlington, VA, USA",
      format: "In-person required",
      topAlumni: "Palantir Technologies, Rebellion Defense, HawkEye 360",
      alumniExits: 0,
      rating: 15
    },
    {
      rank: 53,
      name: "gener8tor",
      companies: 273,
      leader: "Joe Kirgues",
      investment: "$100K for 7%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Madison, Wisconsin, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Curate, EatStreet, dotloop",
      alumniExits: 75,
      rating: 15
    },
    {
      rank: 54,
      name: "Rockstart",
      companies: 243,
      leader: "Rune Theill",
      investment: "€165,000 for 8%",
      fee: "€65,000",
      length: "10 weeks",
      batches: "2x per year",
      companyTypes: "Energy, AgTech",
      acceptance: "Unknown",
      location: "Amsterdam, Netherlands",
      format: "In-person required for specific program events",
      topAlumni: "Wercker, 3D Hubs, Kipenzi",
      alumniExits: 11,
      rating: 15
    },
    {
      rank: 55,
      name: "Eurasante",
      companies: 237,
      leader: "Olivier Coupier",
      investment: "$120K for 8%",
      fee: "No fee information available",
      length: "36 weeks",
      batches: "1x per year",
      companyTypes: "BioTech",
      acceptance: "Unknown",
      location: "Lille, France",
      format: "In-person required 1 day/week",
      topAlumni: "Ynsect, Delibio, Eligo Bioscience",
      alumniExits: 60,
      rating: 15
    },
    {
      rank: 56,
      name: "SAP.iO",
      companies: 234,
      leader: "Christian Klein",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "San Francisco, CA, USA",
      format: "Virtual",
      topAlumni: "NannyML, Airwallex, BigID",
      alumniExits: 12,
      rating: 15
    },
    {
      rank: 57,
      name: "SparkLabs Accelerator",
      companies: 222,
      leader: "Bernard Moon",
      investment: "$100K for 6%",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "IoT",
      acceptance: "<3%",
      location: "Seoul, South Korea",
      format: "In-person required 1st week",
      topAlumni: "Memebox, Knowre, fintechOS",
      alumniExits: 15,
      rating: 15
    },
    {
      rank: 58,
      name: "Orange DAO",
      companies: 220,
      leader: "Ben Huh",
      investment: "$100K uncapped",
      fee: "2% equity stake",
      length: "8 weeks",
      batches: "5x per year",
      companyTypes: "Web3",
      acceptance: "Unknown",
      location: "Undisclosed",
      format: "Virtual",
      topAlumni: "Sublime Finance, Orange DAO Members Pool, Bloom Filter",
      alumniExits: 22,
      rating: 15
    },
    {
      rank: 59,
      name: "SVG Ventures",
      companies: 214,
      leader: "John Hartnett",
      investment: "Investment terms not public",
      fee: "Free",
      length: "12 weeks",
      batches: "1x per year",
      companyTypes: "AgTech",
      acceptance: "Unknown",
      location: "Santa Clara, CA, USA",
      format: "Virtual",
      topAlumni: "Farmers Business Network, ProducePay, Root AI",
      alumniExits: 8,
      rating: 15
    },
    {
      rank: 60,
      name: "Accelerator Centre",
      companies: 210,
      leader: "Ruth Casselman",
      investment: "Investment terms not public.",
      fee: "$3,000",
      length: "52 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Waterloo, Ontario, Canada",
      format: "In-person required 1 day/week",
      topAlumni: "ApplyBoard, Magnet Forensics, Miovision",
      alumniExits: 26,
      rating: 15
    },
    {
      rank: 61,
      name: "Innovation Capital",
      companies: 201,
      leader: "Matt Sodl",
      investment: "Investment terms not public",
      fee: "No fee information available",
      length: "Undisclosed",
      batches: "Unknown",
      companyTypes: "Unknown",
      acceptance: "Unknown",
      location: "Palo Alto, CA, USA",
      format: "Virtual",
      topAlumni: "SoFi, Quincy Data, Zocdoc",
      alumniExits: 22,
      rating: 15
    },
    {
      rank: 62,
      name: "NC IDEA",
      companies: 187,
      leader: "Thom Ruhe",
      investment: "Various grant funding",
      fee: "Free (non-profit)",
      length: "8 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Durham, North Carolina, USA",
      format: "Virtual",
      topAlumni: "TransLoc, Reel Surge, Durham Distillery",
      alumniExits: 58,
      rating: 15
    },
    {
      rank: 63,
      name: "SixThirty",
      companies: 178,
      leader: "Atul Kamra",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "FinTech",
      acceptance: "Unknown",
      location: "St Louis, Missouri, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Dwolla, New Constructs, DataTribe",
      alumniExits: 7,
      rating: 15
    },
    {
      rank: 64,
      name: "India Accelerator",
      companies: 172,
      leader: "Ashish Bhatia",
      investment: "$150,000 for 10%",
      fee: "No fee information available",
      length: "16 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Gurgaon, Haryana, India",
      format: "Hybrid (specifics not public)",
      topAlumni: "Airmeet, Hesa, Knorish",
      alumniExits: 24,
      rating: 15
    },
    {
      rank: 65,
      name: "Quake Capital Partners",
      companies: 166,
      leader: "Glenn Argenbright",
      investment: "$200,000 for 15%",
      fee: "Free",
      length: "12 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "New York City, NY, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Home61, Breinify, Ready Responders",
      alumniExits: 13,
      rating: 15
    },
    {
      rank: 66,
      name: "Stadia Ventures",
      companies: 63,
      leader: "Alex Chalmers",
      investment: "Up to $100,000 for unknown terms",
      fee: "$50",
      length: "14 weeks",
      batches: "1x per year",
      companyTypes: "Sports Tech",
      acceptance: "<3%",
      location: "St. Louis, MO, USA",
      format: "In-person required for specific program events",
      topAlumni: "FanFood, LeagueApps, SportsCastr",
      alumniExits: 9,
      rating: 15
    },
    {
      rank: 67,
      name: "Ben Franklin Technology Partners of Southeastern Pennsylvania",
      companies: 230,
      leader: "Scott Nissenbaum",
      investment: "Matches 1:1 additional capital raised up to $1,000,000",
      fee: "$250 application fee",
      length: "52 weeks",
      batches: "Unknown",
      companyTypes: "FinTech",
      acceptance: "Unknown",
      location: "Philadelphia, PA, USA",
      format: "In-person required",
      topAlumni: "Life Sciences Partners, InstaMed, Spark Therapeutics",
      alumniExits: 60,
      rating: 14
    },
    {
      rank: 68,
      name: "Founder Institute",
      companies: 2000,
      leader: "Adeo Ressi",
      investment: "Does not invest.",
      fee: "$599",
      length: "14 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "30%",
      location: "Palo Alto, CA, USA",
      format: "Virtual",
      topAlumni: "Udemy, Udacity, Realty Mogul",
      alumniExits: 50,
      rating: 14
    },
    {
      rank: 69,
      name: "European Innovation Council",
      companies: 1125,
      leader: "Michiel Scheffer",
      investment: "Grant up to £2.5M",
      fee: "Free (non-profit)",
      length: "52 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "<3%",
      location: "Brussels, Belgium",
      format: "Virtual with in-person demo day",
      topAlumni: "Revolut, UiPath, Glovo",
      alumniExits: 0,
      rating: 14
    },
    {
      rank: 70,
      name: "Internet Initiatives Development Fund (IIDF)",
      companies: 448,
      leader: "Kirill Varlamov",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "12 weeks",
      batches: "3x per year",
      companyTypes: "All",
      acceptance: "3%",
      location: "Moscow, Russia",
      format: "In-person required",
      topAlumni: "Amocrm, Segmento, Ubic.",
      alumniExits: 15,
      rating: 14
    },
    {
      rank: 71,
      name: "AGORANOV",
      companies: 438,
      leader: "Jean Charles Pomerol",
      investment: "Not able to obtain information.",
      fee: "5% equity",
      length: "52 weeks",
      batches: "Unknown",
      companyTypes: "France Startups",
      acceptance: "Unknown",
      location: "Paris, France",
      format: "In-person required",
      topAlumni: "Doctolib, ManoMano, Algolia",
      alumniExits: 80,
      rating: 14
    },
    {
      rank: 72,
      name: "Tenity",
      companies: 319,
      leader: "Andreas Iten",
      investment: "Investment terms not public.",
      fee: "£12,000",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "FinTech",
      acceptance: "3%",
      location: "Zurich, Switzerland",
      format: "In-person required for specific program events",
      topAlumni: "Canopy, Tradeplus24, Relio",
      alumniExits: 11,
      rating: 14
    },
    {
      rank: 73,
      name: "NEXT Canada",
      companies: 312,
      leader: "Reza Satchu",
      investment: "Does not invest.",
      fee: "Free",
      length: "16 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "3%",
      location: "Toronto, Ontario, Canada",
      format: "Hybrid (specifics not public)",
      topAlumni: "Wealthsimple, Clearco, Ada",
      alumniExits: 9,
      rating: 14
    },
    {
      rank: 74,
      name: "Sting",
      companies: 309,
      leader: "Krim Talia",
      investment: "$20K for 4-6%",
      fee: "Free",
      length: "20 weeks",
      batches: "2x per year",
      companyTypes: "Clean Tech",
      acceptance: "5%",
      location: "Stockholm, Sweden",
      format: "In-person required",
      topAlumni: "Peloton, Twitter, Square",
      alumniExits: 26,
      rating: 14
    },
    {
      rank: 75,
      name: "EXPERT DOJO",
      companies: 305,
      leader: "Brian Mac Mahon",
      investment: "$50K for 3.5%",
      fee: "$20,000",
      length: "8 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Santa Monica, CA, USA",
      format: "Virtual",
      topAlumni: "Obligo, ArmorCode, Contrast Security",
      alumniExits: 11,
      rating: 14
    },
    {
      rank: 76,
      name: "DMZ",
      companies: 278,
      leader: "Abdullah Snobar",
      investment: "Investment terms not public",
      fee: "2.5% equity stake",
      length: "12 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Toronto, Ontario, Canada",
      format: "In-person required",
      topAlumni: "Ritual, Snapcommerce, Nudge",
      alumniExits: 90,
      rating: 14
    },
    {
      rank: 77,
      name: "Brinc",
      companies: 257,
      leader: "Manav Gupta",
      investment: "Investment terms not public.",
      fee: "$35,000",
      length: "12 weeks",
      batches: "Unknown",
      companyTypes: "Hardware",
      acceptance: "Unknown",
      location: "Hong Kong",
      format: "Hybrid (specifics not public)",
      topAlumni: "Animoca Brands, Yumi, Carbon Infinity",
      alumniExits: 5,
      rating: 14
    },
    {
      rank: 78,
      name: "100Unicorns",
      companies: 235,
      leader: "Manoj Aheeray",
      investment: "Investment terms not public.",
      fee: "Unknown equity stake",
      length: "8 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Gurugram, Haryana, India",
      format: "Virtual",
      topAlumni: "Darwinbox, Rippling, Airmeet",
      alumniExits: 0,
      rating: 14
    },
    {
      rank: 79,
      name: "Capital Factory",
      companies: 215,
      leader: "Joshua Baer",
      investment: "$100K for 7%",
      fee: "1% equity stake",
      length: "12 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Austin, TX, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Iconeme, Self Lender (now SeedFi), Outdoorsy",
      alumniExits: 55,
      rating: 14
    },
    {
      rank: 80,
      name: "FuturePlay",
      companies: 210,
      leader: "Oh-Hyoung Kwon",
      investment: "Investment terms not public.",
      fee: "$99/month",
      length: "16 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Seoul, South Korea",
      format: "Virtual",
      topAlumni: "Huuuge Games, Two Dots, Deliver Us The Moon",
      alumniExits: 6,
      rating: 14
    },
    {
      rank: 81,
      name: "Bethnal Green Ventures",
      companies: 198,
      leader: "Paul Miller OBE",
      investment: "Investment terms not public",
      fee: "Free",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "Impact",
      acceptance: "Unknown",
      location: "London, United Kingdom",
      format: "Hybrid (specifics not public)",
      topAlumni: "Fairphone, DrDoctor, Organise",
      alumniExits: 13,
      rating: 14
    },
    {
      rank: 82,
      name: "JioGenNext",
      companies: 183,
      leader: "Amey Mashelkar",
      investment: "Investment terms not public",
      fee: "Free",
      length: "12 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Mumbai, India",
      format: "Hybrid (specifics not public)",
      topAlumni: "Jumbotail, Niki.ai, Fynd",
      alumniExits: 5,
      rating: 14
    },
    {
      rank: 83,
      name: "WOW Aceleradora",
      companies: 182,
      leader: "Filipe Garcia",
      investment: "Investment terms not public",
      fee: "No fee information available",
      length: "16 weeks",
      batches: "Unknown",
      companyTypes: "Clean Tech",
      acceptance: "Unknown",
      location: "Porto Alegre, Brazil",
      format: "Hybrid (specifics not public)",
      topAlumni: "Hotmart, Samba Tech, Beblue",
      alumniExits: 17,
      rating: 14
    },
    {
      rank: 84,
      name: "Normandie Incubation",
      companies: 177,
      leader: "Sophie Le Bricquir",
      investment: "Investment terms not public",
      fee: "No fee information available.",
      length: "52 weeks",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Caen, France",
      format: "Hybrid (specifics not public)",
      topAlumni: "Dental Monitoring, Intent, Incepto",
      alumniExits: 42,
      rating: 14
    },
    {
      rank: 85,
      name: "Boomtown Accelerators",
      companies: 175,
      leader: "Toby Krout",
      investment: "$20,000 for unknown percentage",
      fee: "No fee information available",
      length: "12 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Boulder, Colorado, USA",
      format: "In-person required",
      topAlumni: "Samsung SmartThings, Bitsbox, Cardboard Live",
      alumniExits: 16,
      rating: 14
    },
    {
      rank: 86,
      name: "Samurai Incubate",
      companies: 173,
      leader: "Kentaro Sakakibara",
      investment: "$20,000 for 5%",
      fee: "No fee information available",
      length: "12 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Tokyo, Japan",
      format: "In-person required",
      topAlumni: "Raksul, Wantedly, CADDi",
      alumniExits: 17,
      rating: 14
    },
    {
      rank: 87,
      name: "XRC Ventures",
      companies: 166,
      leader: "Pano Anthos",
      investment: "$200,000 for 7%",
      fee: "$50,000",
      length: "8 weeks",
      batches: "Unknown",
      companyTypes: "Consumer Tech",
      acceptance: "Unknown",
      location: "New York City, NY, USA",
      format: "In-person required",
      topAlumni: "Verishop, Terez, UpWest",
      alumniExits: 14,
      rating: 14
    },
    {
      rank: 88,
      name: "Accel Atoms",
      companies: 30,
      leader: "Prayank Swaroop",
      investment: "Up to $1,000,000 for unknown equity",
      fee: "Free",
      length: "12 weeks",
      batches: "1x per year",
      companyTypes: "Artificial Intelligence",
      acceptance: "<1%",
      location: "India",
      format: "In-person required",
      topAlumni: "Unknown",
      alumniExits: 0,
      rating: 13
    },
    {
      rank: 89,
      name: "Start-Up Chile",
      companies: 959,
      leader: "Fernando G",
      investment: "Up to $30,000 in grant funding",
      fee: "Free",
      length: "24 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "5-10%",
      location: "Santiago, Chile",
      format: "Virtual",
      topAlumni: "Cornershop, Houm, SimpliRoute",
      alumniExits: 195,
      rating: 13
    },
    {
      rank: 90,
      name: "Ontario Centres of Excellence",
      companies: 434,
      leader: "Claudia Krywiak",
      investment: "Investment terms not public.",
      fee: "Free",
      length: "Unknown",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Toronto, Ontario, Canada",
      format: "Hybrid (specifics not public)",
      topAlumni: "Clearpath, ecobee, Ritual",
      alumniExits: 0,
      rating: 13
    },
    {
      rank: 91,
      name: "EIT Digital Accelerator",
      companies: 235,
      leader: "Federico Menna",
      investment: "Does not invest.",
      fee: "Free",
      length: "52 weeks",
      batches: "1x per year",
      companyTypes: "Deep Tech",
      acceptance: "Unknown",
      location: "Brussels, Belgium",
      format: "Virtual",
      topAlumni: "Konux, SidekickHealth, Relimetrics",
      alumniExits: 12,
      rating: 13
    },
    {
      rank: 92,
      name: "EvoNexus",
      companies: 228,
      leader: "Rory Moore",
      investment: "Does not invest.",
      fee: "1% equity stake",
      length: "24 weeks",
      batches: "2x per year",
      companyTypes: "BioTech",
      acceptance: "Unknown",
      location: "San Diego, CA, USA",
      format: "Hybrid (specifics not public)",
      topAlumni: "Fate Therapeutics, MDRevolution, EcoATM",
      alumniExits: 27,
      rating: 13
    },
    {
      rank: 93,
      name: "MassChallenge Switzerland",
      companies: 215,
      leader: "Ian Roberts",
      investment: "Does not invest.",
      fee: "Free (non-profit)",
      length: "16 weeks",
      batches: "1x per year",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Renens, Switzerland",
      format: "In-person required",
      topAlumni: "Flyability, Beekeeper, Arianee",
      alumniExits: 5,
      rating: 13
    },
    {
      rank: 94,
      name: "Lotte Ventures",
      companies: 212,
      leader: "Leo Junyoung Ahn",
      investment: "Investment terms not public.",
      fee: "Unknown equity stake",
      length: "Undisclosed",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Seoul, South Korea",
      format: "Hybrid (specifics not public)",
      topAlumni: "FEMTech, Artisans, 42Maru",
      alumniExits: 0,
      rating: 13
    },
    {
      rank: 95,
      name: "LaunchVic",
      companies: 183,
      leader: "Kate Cornick",
      investment: "Does not invest.",
      fee: "Free",
      length: "Undisclosed",
      batches: "Unknown",
      companyTypes: "All",
      acceptance: "Unknown",
      location: "Melbourne, Victoria, Australia",
      format: "Virtual",
      topAlumni: "Mr Yum, Carbar, Airwallex",
      alumniExits: 0,
      rating: 13
    },
    {
      rank: 96,
      name: "Cleantech Open",
      companies: 679,
      leader: "Ken Hayes",
      investment: "Does not invest.",
      fee: "Free (non-profit)",
      length: "32 weeks",
      batches: "1x per year",
      companyTypes: "Clean Tech",
      acceptance: "30%",
      location: "Los Angeles, CA, USA",
      format: "Virtual",
      topAlumni: "ConnectDER, FreeWire Technologies, Enbala",
      alumniExits: 100,
      rating: 12
    },
    {
      rank: 97,
      name: "VentureOut",
      companies: 1095,
      leader: "Brian Frumberg",
      investment: "Does not invest.",
      fee: "6% equity",
      length: "12 weeks",
      batches: "12x per year",
      companyTypes: "Non-US Startups",
      acceptance: "<3%",
      location: "New York City, NY, USA",
      format: "In-person required",
      topAlumni: "Vroom, Simplifeye, Parcel",
      alumniExits: 14,
      rating: 11
    },
    {
      rank: 98,
      name: "Newchip Accelerator",
      companies: 1291,
      leader: "Andrew Ryan",
      investment: "Investment terms not public",
      fee: "$9,000",
      length: "12 weeks",
      batches: "4x per year",
      companyTypes: "All",
      acceptance: "<2%",
      location: "Austin, TX, USA",
      format: "Virtual",
      topAlumni: "DigsFact, Perks, StoryFit",
      alumniExits: 4,
      rating: 10
    },
    {
      rank: 99,
      name: "gbeta",
      companies: 537,
      leader: "Joe Kirgues",
      investment: "Does not invest.",
      fee: "Free",
      length: "7 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<3%",
      location: "Madison, Wisconsin, USA",
      format: "In-person required",
      topAlumni: "Exit, Fetch Rewards, Captivate",
      alumniExits: 26,
      rating: 10
    },
    {
      rank: 100,
      name: "FasterCapital",
      companies: 826,
      leader: "Hesham Zreik",
      investment: "Does not invest.",
      fee: "Free",
      length: "16 weeks",
      batches: "2x per year",
      companyTypes: "All",
      acceptance: "<2%",
      location: "Dubai, United Arab Emirates",
      format: "Virtual",
      topAlumni: "Soukare, EATbilbao, Gener.diabetes",
      alumniExits: 19,
      rating: 9
    }
  ]; 